import { Link, LinkProps } from "@tanstack/react-router";
import { FC } from "react";

type AuthLinkProps = LinkProps & { className?: string };

export const AuthLink: FC<AuthLinkProps> = ({ children, className, ...props }) => {
    return (
        <Link
            className={`text-black underline hover:no-underline hover:text-black${className ? ` ${className}` : ""}`}
            {...props}
        >
            {children}
        </Link>
    );
};
